module.exports = __webpack_public_path__ + "static/media/img_union2.84f9d82c.jpg";